import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { FirebaseReducer } from 'react-redux-firebase';
import { Dispatch } from 'redux';

import { Site } from '../../../utils/classes';
import { fetchSingleSiteScheduleRequest } from '../../../store/reducers/siteSchedule/siteSchedule.action';
import { RootState } from '../../../store/reducers';

export default (
  organizationKey: string,
  siteKey: string,
  site: Site,
  startDate: string,
  endDate: string,
  dispatch: Dispatch,
) => {
  const siteRef = useRef(site);
  siteRef.current = site;

  const auth = useSelector<RootState, FirebaseReducer.AuthState>(state => state.firebase.auth);

  useEffect(() => {
    if (!siteKey || !organizationKey || !startDate || !endDate || !auth.uid) return;

    dispatch(
      fetchSingleSiteScheduleRequest({
        siteKey,
        site: siteRef.current,
        startDate,
        endDate,
        organizationID: organizationKey,
        userID: auth.uid
      })
    );
  }, [siteKey, organizationKey, startDate, endDate, dispatch, auth.uid]);
};
